"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccount = void 0;
const starknet_1 = require("starknet");
function getAccount(config) {
    return new starknet_1.Account(new starknet_1.RpcProvider({ nodeUrl: config.rpcUrl }), config.ownerAddress, new starknet_1.Signer(config.privateKey));
}
exports.getAccount = getAccount;
//# sourceMappingURL=StarknetConfig.js.map